<div class="cads-sparkline-bit">
  <div class="cads-sparkline-bit__frame" #frame [ngStyle]="frameStyle()">
    <canvas #canvas class="cads-sparkline-bit__canvas" role="img" [attr.aria-label]="ariaLabelText()"></canvas>
  </div>
</div>
